/**
 * Entity System Commands
 * 
 * Modular command structure for entity operations.
 * Each command is self-contained in its own file.
 */

import { SelfContainedCommand } from "../../types/commands";
import { entityCreateCommand } from "./entityCreate";
import { entityUpdateCommand } from "./entityUpdate";
import { entityGetCommand } from "./entityGet";
import { entityDeleteCommand } from "./entityDelete";
import { folderCreateCommand } from "./folderCreate";
import { folderListCommand } from "./folderList";
import { entityMoveCommand } from "./entityMove";
import { entityRenameCommand } from "./entityRename"; // ✅ NEW
import { entitiesGroupCommand } from "./entitiesGroup";
import { entitiesUngroupCommand } from "./entitiesUngroup";
import { entityFindCommand } from "./entityFind";
import { entitySearchCommand } from "./entity_search";
import { entityLinkCommand } from "./entityLink";
import { entityUnlinkCommand } from "./entityUnlink";
import { entityListLinksCommand } from "./entityListLinks";
import { spaceGetContextCommand } from "./spaceGetContext";
import { entityTypeCreateCommand } from "./entityTypeCreate";
import { toolCreateCommand } from "./toolCreate";

export const entityCommands: SelfContainedCommand[] = [
  entityCreateCommand,
  entityUpdateCommand,
  entityGetCommand,
  entityDeleteCommand,
  folderCreateCommand,
  folderListCommand,
  entityMoveCommand,
  entityRenameCommand,
  entitiesGroupCommand,
  entitiesUngroupCommand,
  entityFindCommand,
  entitySearchCommand,
  entityLinkCommand,
  entityUnlinkCommand,
  entityListLinksCommand,
  spaceGetContextCommand,
  entityTypeCreateCommand,
  toolCreateCommand
];

export {
  entityCreateCommand,
  entityUpdateCommand,
  entityGetCommand,
  entityDeleteCommand,
  folderCreateCommand,
  folderListCommand,
  entityMoveCommand,
  entityRenameCommand,
  entitiesGroupCommand,
  entitiesUngroupCommand,
  entityFindCommand,
  entitySearchCommand,
  entityLinkCommand,
  entityUnlinkCommand,
  entityListLinksCommand,
  spaceGetContextCommand,
  entityTypeCreateCommand,
  toolCreateCommand
};

